import { html, View } from 'rune-ts';
import { getSharedData, type SharedData } from '../../../util';
import klass from './Icon.module.scss';
import {
  ciety_logo,
  ciety_logo_mini,
  ciety_mco_logo,
  marpple_corp_logo,
  mco_logo,
  mp_logo,
  mp_logo_mini,
  mps_logo,
  mps_logo_mini,
  ness_logo_mini,
} from './icons/logo';
import {
  apple,
  apple_inactive,
  apple_logo,
  ciety_apple_logo,
  ciety_kakao_logo,
  facebook,
  facebook_inactive,
  facebook_logo,
  google,
  google_inactive,
  google_logo,
  kakao,
  kakao_inactive,
  kakao_logo,
  naver,
  naver_inactive,
  naver_logo,
} from './icons/sns';
import {
  ciety_arrow_down,
  ciety_arrow_left,
  ciety_arrow_up,
  ciety_check,
  ciety_close,
  ciety_hide,
  ciety_info,
  ciety_info_color,
  ciety_outlink,
  ciety_pin,
  ciety_remove,
  ciety_round_unlink,
  ciety_unlink,
  ciety_visible,
  mp_arrow_down,
  mp_arrow_left,
  mp_arrow_up,
  mp_check,
  mp_close,
  mp_hide,
  mp_info,
  mp_info_color,
  mp_outlink,
  mp_pin,
  mp_remove,
  mp_round_unlink,
  mp_unlink,
  mp_visible,
  mps_arrow_down,
  mps_arrow_left,
  mps_arrow_up,
  mps_check,
  mps_close,
  mps_hide,
  mps_info,
  mps_info_color,
  mps_outlink,
  mps_pin,
  mps_remove,
  mps_round_unlink,
  mps_unlink,
  mps_visible,
} from './icons/ui';

const icons = {
  // ui
  arrow_down: { Marpple: mp_arrow_down, MarppleShop: mps_arrow_down, Ciety: ciety_arrow_down },
  arrow_up: { Marpple: mp_arrow_up, MarppleShop: mps_arrow_up, Ciety: ciety_arrow_up },
  arrow_left: { Marpple: mp_arrow_left, MarppleShop: mps_arrow_left, Ciety: ciety_arrow_left },
  close: { Marpple: mp_close, MarppleShop: mps_close, Ciety: ciety_close },
  unlink: { Marpple: mp_unlink, MarppleShop: mps_unlink, Ciety: ciety_unlink },
  round_unlink: { Marpple: mp_round_unlink, MarppleShop: mps_round_unlink, Ciety: ciety_round_unlink },
  outlink: { Marpple: mp_outlink, MarppleShop: mps_outlink, Ciety: ciety_outlink },
  remove: { Marpple: mp_remove, MarppleShop: mps_remove, Ciety: ciety_remove },
  visible: { Marpple: mp_visible, MarppleShop: mps_visible, Ciety: ciety_visible },
  hide: { Marpple: mp_hide, MarppleShop: mps_hide, Ciety: ciety_hide },
  check: { Marpple: mp_check, MarppleShop: mps_check, Ciety: ciety_check },
  info: { Marpple: mp_info, MarppleShop: mps_info, Ciety: ciety_info },
  info_color: { Marpple: mp_info_color, MarppleShop: mps_info_color, Ciety: ciety_info_color },
  pin: { Marpple: mp_pin, MarppleShop: mps_pin, Ciety: ciety_pin },

  // logo
  logo: { Marpple: mp_logo, MarppleShop: mps_logo, Ciety: ciety_logo },
  mco_logo: { Marpple: mco_logo, MarppleShop: mco_logo, Ciety: ciety_mco_logo },
  marpple_corp_logo: { Marpple: marpple_corp_logo, MarppleShop: marpple_corp_logo, Ciety: marpple_corp_logo },
  logo_mini: { Marpple: mp_logo_mini, MarppleShop: mps_logo_mini, Ciety: ciety_logo_mini },
  ness_logo_mini: { Marpple: ness_logo_mini, MarppleShop: ness_logo_mini, Ciety: ness_logo_mini },

  // sns
  kakao: { Marpple: kakao, MarppleShop: kakao, Ciety: kakao },
  naver: { Marpple: naver, MarppleShop: naver, Ciety: naver },
  google: { Marpple: google, MarppleShop: google, Ciety: google },
  apple: { Marpple: apple, MarppleShop: apple, Ciety: apple },
  facebook: { Marpple: facebook, MarppleShop: facebook, Ciety: facebook },
  kakao_inactive: { Marpple: kakao_inactive, MarppleShop: kakao_inactive, Ciety: kakao_inactive },
  naver_inactive: { Marpple: naver_inactive, MarppleShop: naver_inactive, Ciety: naver_inactive },
  google_inactive: { Marpple: google_inactive, MarppleShop: google_inactive, Ciety: google_inactive },
  apple_inactive: { Marpple: apple_inactive, MarppleShop: apple_inactive, Ciety: apple_inactive },
  facebook_inactive: { Marpple: facebook_inactive, MarppleShop: facebook_inactive, Ciety: facebook_inactive },
  kakao_logo: { Marpple: kakao_logo, MarppleShop: kakao_logo, Ciety: ciety_kakao_logo },
  naver_logo: { Marpple: naver_logo, MarppleShop: naver_logo, Ciety: naver_logo },
  google_logo: { Marpple: google_logo, MarppleShop: google_logo, Ciety: google_logo },
  apple_logo: { Marpple: apple_logo, MarppleShop: apple_logo, Ciety: ciety_apple_logo },
  facebook_logo: { Marpple: facebook_logo, MarppleShop: facebook_logo, Ciety: facebook_logo },
};

export interface IconData {
  name: keyof typeof icons;
  size?: number;
  fix?: boolean;
  klass?: string;
  theme?: SharedData['theme'];
}

export class Icon extends View<IconData> {
  static icons = icons;

  override template() {
    const theme = this.data.theme ?? getSharedData(this).theme;
    const size =
      (this.data.size ? (this.data.fix ? this.data.size : (this.data.size / 16).toFixed(10)) : 1) +
      (this.data.fix ? 'px' : 'rem');
    return html`<span class="${this.data.klass ?? ''} ${klass.icon}" style="font-size: ${html.preventEscape(size)}"
      >${Icon.icons[this.data.name][theme] ?? Icon.icons[this.data.name].Marpple}</span
    > `;
  }
}
